import { render } from "./SchoolStatistics.vue?vue&type=template&id=670904a3"
import script from "./SchoolStatistics.vue?vue&type=script&lang=js"
export * from "./SchoolStatistics.vue?vue&type=script&lang=js"
script.render = render

export default script